/**
 * CVO Add CVO View
 * Dedicated route component for CVO management
 */

import React from 'react';
import AddCVOView from './AddCVOView';

const CVOAddCVOView = () => {
  return <AddCVOView />;
};

export default CVOAddCVOView;

